<template>
  <div class="tabs is-boxed">
    <ul>
      <li
        v-for="item in items"
        :key="item.name"
        :class="item.isActive ? 'is-active' : ''"
      >
        <template v-if="item.isRoute">
          <router-link :to="{ name: item.link }">
            {{ item.label }}
          </router-link>
        </template>
        <template v-else>
          <a :href="item.link">{{ item.label }}</a>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>